import QueryKeyFactory from "../../../api/hooks/utils/queryKeyFactory";

export const articleKeys = new QueryKeyFactory('article')
export const sharepointKeys = new QueryKeyFactory('sharepoint')
export const categoryKeys = new QueryKeyFactory('category')
export const propertyKeys = new QueryKeyFactory('property')
export const typeKeys = new QueryKeyFactory('type')
export const familyKeys = new QueryKeyFactory('family')

